import { User } from "lucide-react";
import React from "react";

function MyCard3({ className = "", onClick, icon, title, color, value }) {
  const Icon = icon || User;
  return (
    <div
      onClick={() => onClick && onClick()}
      className={`w-full   ${className}    space-x-2 items-center justify-start  flex flex-row rounded-lg border border-gray-300 dark:border-slate-500 `}
    >
      <Icon
        className={`w-8 h-8 p-2 rounded-lg  ${color.text} ${color.icon_bg} `}
      />
      <div className="flex flex-col items-start justify-center space-y-[0px]">
        <span className="text-md font-bold text-slate-600 dark:text-slate-300">
          {value}
        </span>
        <span className="text-[10px] font-normal text-slate-600 dark:text-slate-300">
          {title}
        </span>
      </div>
    </div>
  );
}
export default MyCard3;
